module.exports = __webpack_public_path__ + "static/media/7.14b5775a.jpg";